/*
 *
 * OnboardingContainer actions
 *
 */

import {
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  CREATE_MERCHANT,
  SAVE_USER_DETAILS,
  UPDATE_MERCHANT_DETAILS,
  SAVE_MERCHANT_DETAILS,
  UPDATE_FORM_STATUS,
  UPDATE_LOGIN_FORM,
  AUTHENTICATE_EMAIL_USER,
  AUTHENTICATE_ALIAS,
  GOOGLE_LOGIN,
  GOOGLE_SIGNUP,
  RESET_DATA,
  REDEEM_VOUCHER,
  VALIDATE_TOKEN_SUCCESS,
  TOGGLE_OTP_MODAL,
  VERIFY_LOGIN_OTP,
  STORE_ERROR_LOGIN,
  RESEND_LOGIN_OTP,
  CHECK_EMAIL_EXISTS,
  SET_SIGNUP_FIRST_STEP_DATA,
  SIGNUP_MERCHANT,
  SEND_SIGNUP_OTP,
  VERIFY_IMPORTS,
  VERIFY_EMAIL_OTP,
  RESEND_EMAIL_OTP,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function createMerchantAction(data) {
  return {
    type: CREATE_MERCHANT,
    data,
  };
}

export function saveUserDetails(data) {
  return {
    type: SAVE_USER_DETAILS,
    data,
  };
}

export function updateMerchantDetailsAction(data) {
  return {
    type: UPDATE_MERCHANT_DETAILS,
    data,
  };
}

export function saveMerchantDetails(data) {
  return {
    type: SAVE_MERCHANT_DETAILS,
    data,
  };
}

export function updateFormStatus(data) {
  console.log('updateFormStatus action', data);
  return {
    type: UPDATE_FORM_STATUS,
    data,
  };
}

export function updateLoginFormAction(data) {
  return {
    type: UPDATE_LOGIN_FORM,
    data,
  };
}

export function authenticateEmailUserAction(data) {
  return {
    type: AUTHENTICATE_EMAIL_USER,
    data,
  };
}

export function authenticateAliasAction(data) {
  return {
    type: AUTHENTICATE_ALIAS,
    data,
  };
}

export function googleLoginAction(data) {
  return {
    type: GOOGLE_LOGIN,
    data,
  };
}

export function googleSignupAction(data) {
  return {
    type: GOOGLE_SIGNUP,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function redeemVoucherCodeAction(data) {
  return {
    type: REDEEM_VOUCHER,
    data,
  };
}

export function validateTokenSuccess(data) {
  return {
    type: VALIDATE_TOKEN_SUCCESS,
    data,
  };
}

export function toggleOTPModalAction(data) {
  return {
    type: TOGGLE_OTP_MODAL,
    data,
  };
}

export function verifyLoginOTPAction(data) {
  return {
    type: VERIFY_LOGIN_OTP,
    data,
  };
}

export function storeErrorLoginResponseAction(data) {
  return {
    type: STORE_ERROR_LOGIN,
    data,
  };
}

export function resendLoginOTPAction(data) {
  return {
    type: RESEND_LOGIN_OTP,
    data,
  };
}

export function checkEmailExistsAction(data) {
  return {
    type: CHECK_EMAIL_EXISTS,
    data,
  };
}

export function setSignupFirstStepDataAction(data) {
  return {
    type: SET_SIGNUP_FIRST_STEP_DATA,
    data,
  };
}

export function signupMerchantAction(data) {
  return {
    type: SIGNUP_MERCHANT,
    data,
  };
}

export function sendSignupOTPAction(data) {
  return {
    type: SEND_SIGNUP_OTP,
    data,
  };
}

export function verifyImportsAction(data) {
  return {
    type: VERIFY_IMPORTS,
    data,
  };
}

export function verifyEmailOTPAction(data) {
  return {
    type: VERIFY_EMAIL_OTP,
    data,
  };
}

export function resendEmailOTPAction(data) {
  return {
    type: RESEND_EMAIL_OTP,
    data,
  };
}
